/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactDocumentResponseData,
  GetContactDocumentResponseDataFromJSON,
  GetContactDocumentResponseDataFromJSONTyped,
  GetContactDocumentResponseDataToJSON
} from './GetContactDocumentResponseData'

/**
 *
 * @export
 * @interface GetContactDocumentResponse
 */
export interface GetContactDocumentResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactDocumentResponse
   */
  status?: number
  /**
   *
   * @type {GetContactDocumentResponseData}
   * @memberof GetContactDocumentResponse
   */
  data?: GetContactDocumentResponseData
}

export function GetContactDocumentResponseFromJSON(json: any): GetContactDocumentResponse {
  return GetContactDocumentResponseFromJSONTyped(json, false)
}

export function GetContactDocumentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactDocumentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactDocumentResponseDataFromJSON(json['data'])
  }
}

export function GetContactDocumentResponseToJSON(value?: GetContactDocumentResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactDocumentResponseDataToJSON(value.data)
  }
}
